import React from "react";
import { Link } from "react-router-dom";
import { API, } from "../../../../common/Constants";
import { getAPIHeaders } from "../../../../common/Utils";
import { all_routes } from "../../../router/all_routes";
import PreLoader from "../../../../core/common/preLoader";
import useFetch from "../../../../hooks/useFetch";
import CustomToast from "../../../../core/common/customToast";
import CollapseHeader from "../../../../core/common/collapse-header/collapse-header";
import CopyRightInfo from "../../../../core/common/copyRightInfo";
import CommonTabMenu from "../commonTabMenu";
import SettingsMenu from "./setting-menu";
import ImageWithBasePath from "../../../../core/common/imageWithBasePath";

const FeatureControl = () => {
    const routes = all_routes;
    const { isLoading, callFetch } = useFetch();
    const [toastSettings, setToastSettings] = React.useState<{
        show: boolean;
        message: string;
        heading: string;
        type: "ERROR" | "SUCCESS" | "INFO" | "";
    }>({
        show: false,
        message: "",
        heading: "",
        type: "ERROR",
    });
    const [facultyChatEnabled, setFacultyChatEnabled] = React.useState<boolean>(false);
    const [studentChatEnabled, setStudentChatEnabled] = React.useState<boolean>(false);


    React.useEffect(() => {
        fetchAllSettings();
    }, []);

    const onToastClose = () => {
        setToastSettings({
            show: false,
            message: "",
            heading: "",
            type: "",
        });
    };

    const fetchAllSettings = () => {
        callFetch(API.SETTINGS_ALL,
            'GET',
            getAPIHeaders(),
            null,
            null
        ).then((res) => {
            let enabledFaculty = res?.roleSettings?.FACULTY?.settingGroups?.find((group: any) => group.category === 'AI')?.
                            settings?.find((setting: any) => setting.settingKey === 'AI_CHAT_ASSISTANT_ENABLED')?.currentValue || false ;
            let enabledStudent = res?.roleSettings?.STUDENT?.settingGroups?.find((group: any) => group.category === 'AI')?.
                            settings?.find((setting: any) => setting.settingKey === 'AI_CHAT_ASSISTANT_ENABLED')?.currentValue || false ;

            setFacultyChatEnabled(enabledFaculty === 'true' || enabledFaculty === true);
            setStudentChatEnabled(enabledStudent === 'true' || enabledStudent === true);
        }).catch((err) => { 
            setToastSettings({
                show: true,
                message: "Failed to fetch feature settings.",
                heading: "Error",
                type: "ERROR",
            });
        });
    }

    const updateFeatureSetting = (role: string, enabled: boolean) => {
        const payload = {
            settingKey: "AI_CHAT_ASSISTANT_ENABLED",
            scope: "ROLE",
            roleType: role,
            value: enabled ? "true" : "false"
        };

        callFetch(API.SETTINGS_UPDATE,
            'PUT',
            getAPIHeaders(),
            null,
            payload
        ).then((res) => {
            fetchAllSettings();
            setToastSettings({
                show: true,
                message: `Feature ${enabled ? 'enabled' : 'disabled'} successfully.`,
                heading: "Success",
                type: "SUCCESS",
            });
        }).catch((err) => {
            setToastSettings({
                show: true,
                message: "Failed to update feature setting.",
                heading: "Error",
                type: "ERROR",
            });
        });
    }

    const renderFacultyChatAssistant = () => {
        return (<div className="card flex-fill">
            <div className="card-body">
                <div className="border-bottom pb-3 mb-3">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <div className="d-flex align-items-center">
                            <span className="avatar avatar-xl p-2 me-2 bg-light flex-shrink-0">
                                <ImageWithBasePath src="assets/img/icons/teacher.png" alt="img" />
                            </span>
                            <h5>Faculty APP Chat Assistant</h5></div><div className="form-check form-switch">
                            <input className="form-check-input" role="switch" id="flexSwitchCheckDefault"
                                   type="checkbox"  checked={facultyChatEnabled}
                                   onChange={(e) => updateFeatureSetting("FACULTY", e.target.checked)} />
                        </div>
                    </div>
                    <p>Chat assistant for faculty members in mobile app.</p>
                </div>

            </div>
        </div>)
    }

    const renderStudentChatAssistant = () => {
        return (<div className="card flex-fill">
            <div className="card-body">
                <div className="border-bottom pb-3 mb-3">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <div className="d-flex align-items-center">
                            <span className="avatar avatar-xl p-2 me-2 bg-light flex-shrink-0">
                                <ImageWithBasePath src="assets/img/icons/student.png" alt="img" />
                            </span>
                            <h5>Student APP Chat Assistant</h5></div><div className="form-check form-switch">
                            <input className="form-check-input" role="switch" id="flexSwitchCheckDefault"
                                 type="checkbox" checked={studentChatEnabled} onChange={(e) => updateFeatureSetting("STUDENT", e.target.checked)} />
                        </div>
                    </div>
                    <p>Chat assistant for student members in mobile app.</p>
                </div>
            </div>
        </div>)
    }

    return (
        <div>
            <>
                <CustomToast
                    show={toastSettings?.show}
                    message={toastSettings?.message}
                    heading={toastSettings?.heading}
                    type={toastSettings?.type || "INFO"}
                    onClose={onToastClose} />
                <PreLoader showLoader={isLoading} />
                {/* Page Wrapper */}
                <div className="page-wrapper">
                    <div className="content">
                        {/* Breadcrumb */}
                        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                            <div className="my-auto mb-2">
                                <h2 className="mb-1">Application Settings</h2>
                                <nav>
                                    <ol className="breadcrumb mb-0">
                                        <li className="breadcrumb-item">
                                            <Link to={routes.adminDashboard}>
                                                <i className="ti ti-smart-home" />
                                            </Link>
                                        </li>
                                        <li className="breadcrumb-item">Administration</li>
                                        <li className="breadcrumb-item active" aria-current="page">
                                            Settings
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                            <div className="head-icons ms-2">
                                <CollapseHeader />
                            </div>
                        </div>
                        {/* /Breadcrumb */}
                        <CommonTabMenu activeTab="AppSettings" />
                        <div className="row">
                            <div className="col-xl-3 theiaStickySidebar">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="d-flex flex-column list-group settings-list">
                                            <SettingsMenu activeTab="FeatureControl" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-9">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="border-bottom mb-3 pb-3">
                                            <h4>Feature Turn On / Off</h4>
                                        </div>
                                        <form>
                                            <div className="border-bottom mb-3">
                                                <div className="row"></div>
                                                <div className="row">
                                                    <div className="col-md-6 d-flex">
                                                        {renderFacultyChatAssistant()}
                                                    </div>

                                                    <div className="col-md-6 d-flex">
                                                        {renderStudentChatAssistant()}
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3">
                        <CopyRightInfo />
                    </div>
                </div>
                {/* /Page Wrapper */}
            </>

        </div>
    );
}

export default FeatureControl